import { usePageContext } from '@abg/web-core/context/page/client-provider';

import { createLocationUrl } from '../../../../../shared/location';
import { LocationSuggestionOption } from '../../../location-search.types';

export const useLocationPageUrl = (
  location: Pick<LocationSuggestionOption, 'regionCode' | 'relPath'>,
): string => {
  const { navigationLinks } = usePageContext();

  const { relPath } = location;

  return createLocationUrl({ rootPath: navigationLinks.rootPath, relPath });
};
